export const POS_SALE_POLICY_READ = 'pos_sale_policy.read';
export const POS_SALE_POLICY_WRITE = 'pos_sale_policy.write';

const POS_POLICY_CODE_BY_ROLE: Record<number, string[]> = {
  1: [POS_SALE_POLICY_READ, POS_SALE_POLICY_WRITE], // root
  2: [POS_SALE_POLICY_READ, POS_SALE_POLICY_WRITE], // owner
  3: [POS_SALE_POLICY_READ, POS_SALE_POLICY_WRITE], // manager
  4: [], // technician
  5: [POS_SALE_POLICY_READ], // receptionist
};

export type PermissionProfile = {
  role_id?: number | null;
  permission_codes?: string[] | null;
};

const normalizeCodes = (codes?: string[] | null): Set<string> => {
  if (!codes?.length) {
    return new Set<string>();
  }
  const normalized = codes
    .map((code) => String(code || '').trim().toLowerCase())
    .filter((code) => code.length > 0);
  return new Set<string>(normalized);
};

export const hasPermissionCode = (
  profile: PermissionProfile | null | undefined,
  code: string,
): boolean => {
  const normalizedCode = String(code || '').trim().toLowerCase();
  if (!normalizedCode) {
    return false;
  }
  const normalizedCodes = normalizeCodes(profile?.permission_codes);
  if (normalizedCodes.size > 0) {
    return normalizedCodes.has(normalizedCode);
  }

  const roleID = Number(profile?.role_id || 0);
  const roleCodes = POS_POLICY_CODE_BY_ROLE[roleID] ?? [];
  return roleCodes.some((roleCode) => roleCode === normalizedCode);
};
